<template>
    <div class="top-bar">
        <div class="top-bar-content" :class="{ 'left-logo' :leftLogo }">
            <div class="d-flex">
                <div class="flex-fill">
                    <div class="back-btn" v-if="showBack && !leftLogo" @click="clickBack()">
                        <img src="@/assets/img/01-register/ic-back@3x.png">
                    </div>
                    <div class="title" v-if="title">{{title}}</div>
                    <img class="img-logo" v-if="!title" src="@/assets/img/01-register/logo-small@3x.png">
                </div>
                <div class="text-white" v-if="isShowSidebar">
                    <Menusidebar :isShow="isShowSidebar" @clickMembership="onClickMembership()"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
/**
 * @property {Boolean} showBack
 * @property {Boolean} leftLogo
 * @event onClickBack
 */
import Menusidebar from '@/components/MenuSidebar.vue'
export default {
    name: 'top-bar',// <top-bar>
    components:{
        Menusidebar
    },
    props: {
        showBack: Boolean,
        leftLogo: Boolean,
        title: String,
        isShowSidebar: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        clickBack: function() {
            this.$emit('onClickBack');
        },
        onClickMembership: function(){
            this.$emit('onClickMembership');
        }
    },
}
</script>
<style lang="scss" scoped>
    .top-bar {
        background-color: #000;
    }
    .top-bar-content {
        color: #fff;
        font-weight: bold;
        font-size: 2rem;
        text-align: center;
        padding: 10px 0px;
        position: relative;

        &.left-logo {
            text-align: left;
            padding-left: 15px;
        }

        .back-btn {
            position: absolute;
            width: 13px;
            top: 7px;
            left: 15px;

            img {
                width: 100%;
            }
        }

        .title {
            text-align: left;
            padding: 10px 0px 10px 60px;
            font-size: 1.3rem;
            font-weight: normal;
        }
    }
    .img-logo {
        vertical-align: top;
        width: 100px;
        margin-top: 10px;
    }
</style>
